/** @jsxImportSource @emotion/react */

import Box from "@mui/material/Box";
import R, { headerHeight, size } from "../../../R";
import MaxWidthLayout from "../../../components/layouts/MaxWidthLayout";
import useIsMobile from "../../../hooks/device/useIsMobile";

interface HeaderContainerProps {
  readonly children?: React.ReactNode;
  readonly className?: string;
}

function HeaderContainer({ children, className }: HeaderContainerProps) {
  const isMobile = useIsMobile();

  return (
    <MaxWidthLayout>
      <Box
        id="head-content"
        flexDirection="row"
        position="relative"
        css={{
          height: headerHeight,
          backgroundColor: R.colors.white,
          boxShadow: "0px 3px 8px rgba(54, 59, 100, 0.05)",
          borderRadius: isMobile ? 0 : size.radius.small,
          marginTop: isMobile ? "0" : "1.25rem",
          marginLeft: 0,
          marginRight: 0,
          marginBottom: isMobile ? "none" : size.padding.medium,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        className={className}
      >
        {children}
      </Box>
    </MaxWidthLayout>
  );
}

export default HeaderContainer;
